import React from 'react';
import { Container } from 'reactstrap';

const Error404 = () => {
  return (
    <Container> 
    <h1 style={
      {
        textAlign:'center',
        margin: "100px auto 400px auto"
      }
    }>Error 404</h1>
    </Container>
  );
}
export default Error404;
